<template>
  <div
    :style="{ background }"
    class="value-proposition-container"
  >
    <span :style="{ color }">{{ value }}</span>
  </div>
</template>

<script>
import { hexToRgba } from '@/helpers/colors';

export default {
  name: 'HomeTabValueProposition',
  props: {
    value: {
      type: String,
      default: '',
    },
    color: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      background: '',
    };
  },
  watch: {
    color: {
      immediate: true,
      async handler() {
        this.background = await hexToRgba(this.color, 0.05);
      },
    },
  },
};
</script>

<style lang="less" scoped>
.value-proposition-container {
  padding: 10px 13px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-start;

  span {
    font-size: 14px;
    font-weight: 300;
  }
}
</style>
